import React, {useState, useEffect, useContext} from 'react';
import axios from "../common/axios";
import {UserContext} from "../common/UserContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import {CrossIcon, PlusIcon} from '../common/icons/';
import Tooltip from "../common/Tooltip";
import ListItem from "../common/ListItem";

const AdminSchoolSelector = props => {
    const {handleClose} = props;
    const {user, loadUser} = useContext(UserContext);
    const {loadShortcutByUrl} = useCurrentShortcut();
    const shortcutUrl = '/administration/school/manageSchools.action';

    const handleClearSchool = () => {
        axios.get('/web/ui/sc/clearSchool')
            .then(response => {
                loadUser();
                handleClick(false);
            });
    }

    const handleClick = (viewSchool) => {
        let activeTabId = viewSchool ? 1 : 0;
        loadShortcutByUrl(shortcutUrl, {viewSchool: viewSchool});

        if (window.location.pathname === shortcutUrl) {
            window.dispatchEvent(new CustomEvent('schoolTabSelector', {detail: activeTabId}));
        }

        handleClose();
    }

    return (
        <>
            {user.actForSchoolId === undefined &&
                <ListItem onClick={() => {handleClick(false)}}>
                    <span className={'text-muted'}>No School</span>
                </ListItem>
            }
            {user.actForSchoolId !== undefined &&
                <div className={'ch-list-item ch-nav-item'}>
                    <Tooltip title={user.actForSchoolName.length > 17 ? user.actForSchoolName : ''} placement="bottom" enterNextDelay={100} disableInteractive>
                        <span className={'ch-shortcut-link ch-highlight'} onClick={() => {handleClick(true)}}>{user.actForSchoolName}</span>
                    </Tooltip>
                    <Tooltip title={'Clear School'} placement="bottom" enterNextDelay={100} disableInteractive>
                        <span className={'ch-admin-school-icon'} onClick={handleClearSchool}>
                            <CrossIcon />
                        </span>
                    </Tooltip>
                </div>
            }
        </>
    )
}

export default AdminSchoolSelector;